var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"lucide-icon",attrs:{"data-lucide":"clock"}})
}
var staticRenderFns = []

export { render, staticRenderFns }